export enum SupersessionKey {
  SupersededId = 'superseded-from-id',
  SupersededName = 'superseded-from-name',
  Inventory = 'inventory'
}
